export var TenantUserRole;
(function (TenantUserRole) {
    TenantUserRole[TenantUserRole["Owner"] = 0] = "Owner";
    TenantUserRole[TenantUserRole["Admin"] = 1] = "Admin";
    TenantUserRole[TenantUserRole["Viewer"] = 2] = "Viewer";
    TenantUserRole[TenantUserRole["Other"] = 3] = "Other";
})(TenantUserRole || (TenantUserRole = {}));
